export enum CustomFacetContentType {
  Checkbox = 'CHECKBOX',
  Range = 'RANGE',
  Tree = 'TREE_VIEW',
  Multiselect = 'MULTISELECT',
  MyShop = 'MY_SHOP',
  Subcategories = 'SUBCATEGORIES',
}

export enum CustomFacetCodes {
  MyShop = 'myShop',
  Category = 'category',
}
